import React from 'react';
import { Card } from '@heroui/react';
import FeaturesMarkup from '@components/plans/features-markup';
import PlanBadge from '@components/plans/plan-badge';
import { PlanInfo } from '@/types';

interface FreePlanCardProps {
	plan: PlanInfo;
	isActive: boolean;
}

const FreePlanCard: React.FC<FreePlanCardProps> = ({ plan, isActive }) => {
	return (
		<Card>
			<Card.Header>
				<PlanBadge plan={plan} isActive={isActive} />
			</Card.Header>
			<Card.Content className='pb-5'>
				<p className='text-xl font-bold mb-5 block'>${plan.price}/monthly</p>
				<div className='flex mt-[6px]'>
					<div className='mb-[6px] h-[350px]'>
						<FeaturesMarkup planDescription={plan.description} />
					</div>
				</div>
			</Card.Content>
		</Card>
	);
};

export default FreePlanCard;
